module.exports = __webpack_public_path__ + "img/avatar0.960e6f95.png";